import React from 'react';
import { Modal } from 'react-bootstrap';
import * as ArrayExtensions from '../../../../utils/CoreExtensions/ArrayExtensions';
import { closeActionRenderer } from './utils';
import { mergeProps } from '../mergeProps';
import clsx from 'clsx';

const ChrModal = props => {
  const closeAction = closeActionRenderer(props);

  let footerContent = [];
  if (props.includeCloseAction) footerContent.push(closeAction);
  if (props.footer) footerContent.push(props.footer);

  let extraModalBodyProps = props.extraModalBodyProps || {};
  let { showHeaderCloseButton = true } = props;

  const softHiddenProps = {
    className: clsx({ hide: props.isSoftHidden }),
    backdropClassName: clsx({ hide: props.isSoftHidden })
  };

  const extraModalOptions = mergeProps(props.extraModalOptions, softHiddenProps);

  return (
    <React.Fragment>
      <Modal
        show={ props.show }
        onHide={ props.hideModal }
        bsSize={ props.size }
        animation={ !props.noAnimation }
        container={ document.querySelector('.cui-scoped-new-ux-support-modal-container .cui-scoped-new-ux-support-outer-wrapper .cui-scoped-new-ux-support-inner-wrapper') }
        { ...extraModalOptions }
      >
        { !props.hideHeader && <Modal.Header closeButton={showHeaderCloseButton} onHide={ props.closeButtonOnClickHandler } className={`d-block cui-react-modal-header ${showHeaderCloseButton ? '' : 'close-button-hidden'} ${props.headerClassName}`}>
          <Modal.Title>
            { props.header }
          </Modal.Title>
        </Modal.Header> }
        <Modal.Body { ...extraModalBodyProps }>
          { props.body || props.children }
        </Modal.Body>
        { ArrayExtensions.isPresent(footerContent) &&
          <Modal.Footer bsClass={ `modal-footer ${props.footerClassName}` }>
            { footerContent }
          </Modal.Footer>
        }
      </Modal>
    </React.Fragment>
  );
};

export default ChrModal;
